export default __webpack_public_path__ + "static/media/mobile.e5827eda.png";